import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'inspirationSource'

const OPTIONS = [
  {
    value: 'Pinterest & Instagram',
    translationKey: 'pages.onboarding.v1.inspirationSource.options.social',
    emoji: '📱',
  },
  {
    value: 'Design magazines',
    translationKey: 'pages.onboarding.v1.inspirationSource.options.magazines',
    emoji: '📖',
  },
  {
    value: 'Friends & family homes',
    translationKey: 'pages.onboarding.v1.inspirationSource.options.friends',
    emoji: '👥',
  },
  {
    value: 'Hotels & restaurants',
    translationKey: 'pages.onboarding.v1.inspirationSource.options.hotels',
    emoji: '🏨',
  },
  {
    value: 'I struggle to find inspiration',
    translationKey: 'pages.onboarding.v1.inspirationSource.options.struggle',
    emoji: '😕',
  },
]

export default function InspirationSourcePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Where do you usually find design inspiration?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.inspirationSource.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
